"use client";

import { useIntersectionObserver } from "@uidotdev/usehooks";
import Link from "next/link";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import type { ReactNode } from "react";
import type { InfoCard } from "../../types/content/infoCard";

import { usePulse } from "../../pulse/usePulse";
import styles from "./InfoCard.module.scss";
import { useArticleModalStore } from "../../store/useArticleModalStore";
const InfoCardLink = ({
  article,
  slug,
  externalLink,
  children,
}: {
  article: InfoCard;
  externalLink?: string;
  slug?: string;
  children: ReactNode;
}) => {
  const { trackInfoCardClick } = usePulse();

  const [ref, entry] = useIntersectionObserver<HTMLAnchorElement>({
    threshold: 2 / 3,
  });
  const inView = entry?.isIntersecting ?? false;
  const { trackInfoCardImpression } = usePulse();
  const { openModal } = useArticleModalStore();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (inView && article) {
      trackInfoCardImpression({ article });
    }
  }, [inView, article, trackInfoCardImpression]);

  return (
    <Link
      href={externalLink ? externalLink : `/${slug}/a/${article.article_id}`}
      className={styles.link}
      rel={"canonical"}
      ref={ref}
      prefetch={true}
      scroll={false}
      onClick={() => {
        trackInfoCardClick({ article });
      }}
      onNavigate={
        externalLink
          ? undefined
          : () =>
              openModal(
                searchParams.size > 0
                  ? `${pathname}?${searchParams}`
                  : pathname,
              )
      }
    >
      {children}
    </Link>
  );
};

export { InfoCardLink };
